import logo from "../ifach.png";
import Menu from "./Menu";

const Header = () => {
    
    return (
        <header id="header" className="App-header">
            <Menu />
            <img src={logo} className="App-logo" alt="logo calpecoin" />
            <h1 style={{ marginTop: `2rem` }}>Calpecoin</h1>
        </header>
    )
}

export default Header